import React, { useMemo } from 'react';
import { isEmpty } from 'lodash';
import useOrganisationGroups from '../../../data/hooks/useOrganisationGroups';
import SpinnerError from '../../utils/SpinnerError';
import useLabel from '../../utils/Translations/useLabel';
import useT from '../../utils/Translations/useT';
import { RETURN_TYPE } from '../base/SelectBox';
import useResetOnDeps from './hooks/useResetOnDeps';
import MultiselectFilter from './MultiselectFilter';
import SelectBoxFilter from './SelectBoxFilter';
const OrganisationGroupSelector = ({ value, onChange, title, isMultiple = true, hasLiveSearch = false, tenantId, isDisabled = false, returnType = RETURN_TYPE.OPTION, options, error: outerError, loading: outerLoading, ...props }) => {
    const t = useT();
    const _title = useLabel('Organisation Group', title);
    useResetOnDeps({ tenantId }, onChange, isMultiple ? [] : null);
    const { models: _models, loading: _loading, error: _error, } = useOrganisationGroups({
        tenantId,
    }, { skip: !isEmpty(options) });
    const models = useMemo(() => (!isEmpty(options) ? options : _models) || [], [
        options,
        _models,
    ]);
    const loading = useMemo(() => outerLoading || _loading, [
        _loading,
        outerLoading,
    ]);
    const error = useMemo(() => outerError || _error, [_error, outerError]);
    const GroupTitleKeys = useMemo(() => [null, t('Other Entities')], [t]);
    return (<SpinnerError error={error} inline={false} loading={loading}>
      {isMultiple ? (<MultiselectFilter disabled={isDisabled} groupTitleKeys={GroupTitleKeys} liveSearch={hasLiveSearch} options={models} orderOptionsBy="name" title={_title} value={value || []} onChange={onChange} {...props}/>) : (<SelectBoxFilter disabled={isDisabled} itemValuePropName="id" liveSearch={hasLiveSearch} options={models} returnType={returnType} title={_title} value={value} onChange={onChange} {...props}/>)}
    </SpinnerError>);
};
export default OrganisationGroupSelector;
